export const sanitizeCompanyName = (companyName: string) => {
    const rx = new RegExp("[^\\p{L}0-9 !,#()&.?/'\\-+]", 'gu')
    const companyNameSanitized = companyName.replace(/@/g, '').replace(/_/g, '').replace(rx, '')
    return companyNameSanitized
}
